import { getBearerToken } from "../../../api/postCall/bearerToken";
import { CoverMyMedsInputModel } from "../../../data-model/cmmInputRequestModel";
import { API_ENDPOINTS } from "../../../enums/apiUrls";
import { logDataToConsole, logError } from "../../../utils/customLogger";

const getAuthHeaders = async (): Promise<Record<string, string>> => {
  const token = await getBearerToken();
  return {
    Authorization: `Bearer ${token}`,
  };
};

interface RunStatusTrackingBatchPayload {
  cover_my_meds_input_list: CoverMyMedsInputModel[];
  batch_id: string;
  batch_index: number;
  total_batches: number;
}

export const runStatusTrackingBatch = async (
  signal: AbortSignal,
  payload: RunStatusTrackingBatchPayload,
): Promise<any> => {
  try {
    const headers = await getAuthHeaders();

    const requestOptions: RequestInit = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...headers,
      },
      body: JSON.stringify(payload),
      redirect: "follow",
      signal,
    };

    const response = await fetch(
      API_ENDPOINTS.RUN_STATUS_TRACKING_BATCH,
      requestOptions,
    );

    if (!response.ok) {
      logError(
        new Error(`HTTP error! Status: ${response.status}`),
        "Error in runStatusTrackingBatch",
      );
    }

    const result = await response.json();
    logDataToConsole("Run Status Tracking Batch Response", result);

    return result;
  } catch (error) {
    logError(error as Error, "Error in runStatusTrackingBatch");
  }
};
